"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DMSNodeState;
(function (DMSNodeState) {
    DMSNodeState["NODE_STATE_IDLE"] = "IDLE";
    DMSNodeState["NODE_STATE_SOFTWARE_UPDATE_STARTED"] = "SOFT_UPDATE_STARTED";
    DMSNodeState["NODE_STATE_SOFTWARE_UPDATE_SUCCEEDED"] = "SOFT_UPDATE_SUCCEEDED";
    DMSNodeState["NODE_STATE_SOFTWARE_UPDATE_FAILED"] = "SOFT_UPDATE_FAILED";
    DMSNodeState["NODE_STATE_CONFIG_UPDATE_STARTED"] = "CFG_UPDATE_STARTED";
    DMSNodeState["NODE_STATE_CONFIG_UPDATE_SUCCEEDED"] = "CFG_UPDATE_SUCCEEDED";
    DMSNodeState["NODE_STATE_CONFIG_UPDATE_FAILED"] = "CFG_UPDATE_FAILED";
    DMSNodeState["NODE_STATE_RESTARTING"] = "RESTARTING";
})(DMSNodeState || (DMSNodeState = {}));
exports.default = DMSNodeState;
//# sourceMappingURL=DMSNodeState.js.map